/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStates,ISymbolStateConfig,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export interface IImmortalFruitsSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    land:ISymbolStateConfig;
    idle:ISymbolStateConfig;
}

export class ImmortalFruitsReelSymbol extends StateReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }
    /**
     * @inheritDoc
     * @override To implement spine as State in some of the symbols.
     * @param timeline
     * @param newState
     * @param stateAnimation
     * @param delay
     */
    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        const symName: string = this.symName,
            spineStates: string[] = ["Idle", "Land"],
            stateKey: string = newState.state.keyword;

        let loopCount: number = 0;

        if (spineStates.indexOf(stateKey) !== -1 && (symName === "S")) {
            let animName ="_idle";
            if(stateKey=="Land"){
                animName ="_landing"
            }else if(stateKey=="Idle"){
                animName ="_idle"
            }
            if ((stateKey === spineStates[0] || stateKey === spineStates[1]||stateKey === spineStates[3]) && (symName === "S")) {
                loopCount = 0;
            }
            timeline.add(new SpineTween((stateAnimation as any), 0, "bonus" + animName , loopCount), delay);
            if (stateKey === spineStates[1] || stateKey === spineStates[2]) {
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
            }
            else {
                stateAnimation.alpha = 1;
            }

            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if(newState.state.keyword === ImmortalFruitsGameConfig.instance.SYMBOL_STATES.win.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.35, {x : 1.2, y : 1.2}));
            winTl.add(() => new TweenLite(this.scale, 0.35, {x : 1, y : 1, delay :0.35}));
            timeline.add(winTl,delay);
            return;
        }
    }
}